import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import PropTypes from 'prop-types';
import '../styles/profile-completion-banner.css';

/**
 * Banner que se muestra cuando el usuario no ha completado su perfil extendido
 * Aparece en la parte superior de la aplicación para usuarios con perfil incompleto
 */
const ProfileCompletionBanner = ({ onCompleteProfile, onDismiss, showDismiss = true }) => {
  const { user } = useAuth();
  const [isDismissed, setIsDismissed] = useState(false);

  // No mostrar el banner si:
  // - El usuario no existe
  // - El perfil está completo
  // - El usuario no es de tipo 'user'
  // - El banner ha sido descartado
  if (!user || user.profileCompleted || user.role !== 'user' || isDismissed) {
    return null;
  }

  const handleDismiss = () => {
    setIsDismissed(true);
    if (onDismiss) {
      onDismiss();
    }
  };

  const handleCompleteProfile = () => {
    if (onCompleteProfile) {
      onCompleteProfile();
    }
  };

  const reminderCount = user.profileCompletionReminders || 0;
  const isFirstTime = reminderCount <= 1;

  return (
    <div className="profile-completion-banner">
      <div className="banner-content">
        <div className="banner-icon">
          <span className="material-icons">info</span>
        </div>
        
        <div className="banner-message">
          <h4>
            {isFirstTime 
              ? '¡Completa tu perfil para una mejor experiencia!' 
              : `Recordatorio ${reminderCount}: Completa tu perfil`
            }
          </h4>
          <p>
            {isFirstTime
              ? 'Para aprovechar al máximo ProKidsApp, necesitamos algunos datos adicionales. Solo te tomará unos minutos.'
              : 'Aún necesitamos algunos datos para completar tu perfil. ¡Es rápido y fácil!'
            }
          </p>
        </div>

        <div className="banner-actions">
          <button 
            className="btn btn-primary btn-sm"
            onClick={handleCompleteProfile}
          >
            Completar Perfil
          </button>
          
          {showDismiss && (
            <button 
              className="btn btn-link btn-sm"
              onClick={handleDismiss}
            >
              Más tarde
            </button>
          )}
        </div>

        {showDismiss && (
          <button 
            className="banner-close"
            onClick={handleDismiss}
            aria-label="Cerrar notificación"
          >
            <span className="material-icons">close</span>
          </button>
        )}
      </div>
    </div>
  );
};

ProfileCompletionBanner.propTypes = {
  onCompleteProfile: PropTypes.func.isRequired,
  onDismiss: PropTypes.func,
  showDismiss: PropTypes.bool,
};

export default ProfileCompletionBanner;
